class PedagioEnum {
  constructor() {
    this.PEDAGIO_INCLUSO = 1;
    this.SEM_PEDAGIO = 2;
    this.COM_PEDAGIO = 3;
  }

  getTiposLabel() {
    return [
      { label: 'Pedágio incluso', value: this.PEDAGIO_INCLUSO },
      { label: 'Sem pedágio', value: this.SEM_PEDAGIO },
      { label: 'Com pedágio', value: this.COM_PEDAGIO },
    ];
  }

  getTipo(pedagio) {
    return this.getTiposLabel()
      .filter(label => label.value === pedagio)
      .shift();
  }
}

export default new PedagioEnum();
